var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5141 9.09767L18.5249 0.949219H16.8636L10.7761 8.02441L5.91398 0.949219H0.306152L7.65857 11.6482L0.306152 20.1931H1.96759L8.39616 12.7214L13.5309 20.1931H19.1387L11.5137 9.09767H11.5141ZM9.23851 11.7424L8.49356 10.677L2.56623 2.19976H5.1181L9.90153 9.0412L10.6465 10.1066L16.8644 18.9994H14.3125L9.23851 11.7428V11.7424Z",
    fill: "#A392FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.7e2f389aac0dbbba07fcff3a40cc6bf9.svg";
export { ForwardRef as ReactComponent };